import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { trigger, transition, style, animate } from '@angular/animations';
import { ErrorService, ErrorMessage } from '../../services/error.service';

/**
 * Componente genérico para exibir mensagens de sucesso, erro, aviso e informação.
 * Consome o ErrorService (errors$) e exibe toasts no canto da tela.
 * Uso: ErrorService.showSuccessMessage('Cliente criado com sucesso') ou showErrorMessage('...').
 */
@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.css'],
  animations: [
    trigger('slideIn', [
      transition(':enter', [
        style({ transform: 'translateX(100%)', opacity: 0 }),
        animate('300ms ease-out', style({ transform: 'translateX(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('250ms ease-in', style({ transform: 'translateX(100%)', opacity: 0 }))
      ])
    ])
  ]
})
export class MessageComponent implements OnInit, OnDestroy {
  messages: ErrorMessage[] = [];
  private destroy$ = new Subject<void>();

  constructor(private errorService: ErrorService) {}

  ngOnInit(): void {
    this.errorService.errors$
      .pipe(takeUntil(this.destroy$))
      .subscribe(list => {
        this.messages = list;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  close(id: string): void {
    this.errorService.removeError(id);
  }

  getIcon(type: string): string {
    switch (type) {
      case 'success': return 'fa-check-circle';
      case 'error': return 'fa-times-circle';
      case 'warning': return 'fa-exclamation-triangle';
      case 'info': return 'fa-info-circle';
      default: return 'fa-bell';
    }
  }

  getTitle(type: string): string {
    switch (type) {
      case 'success': return 'Sucesso';
      case 'error': return 'Erro';
      case 'warning': return 'Aviso';
      case 'info': return 'Informação';
      default: return 'Mensagem';
    }
  }

  getModifierClass(type: string): string {
    return `message-toast--${type}`;
  }

  trackById(_index: number, item: ErrorMessage): string {
    return item.id;
  }
}
